import React, { useState, useEffect } from 'react';
import styles from './Navbar.module.css';
import { Link, useLocation } from 'react-router-dom';

import { HiMenu } from 'react-icons/hi';
import { RiCloseFill, RiArrowDropDownLine } from 'react-icons/ri';
import { FaMinus } from 'react-icons/fa';
import { GoPlus } from 'react-icons/go';

import menuJson from './menu.json';

const lngs = {
    en: { displayName: 'EN' },
    el: { displayName: 'EL' }
};

const DESKTOP_BREAKPOINT = 1200;

const Dropdown = ({ elem, width }) => {
    const [subLinkToggle, setSubLinkToggle] = useState(false);

    return (
        <div className={styles.dropdown}>
            <div className={styles.dropdownContainer}>
                <Link to={elem.url} className={styles.dropBtn}>
                    {elem.title}
                </Link>
                {width >= DESKTOP_BREAKPOINT && <RiArrowDropDownLine size={'35px'} />}
                {width < DESKTOP_BREAKPOINT && (
                    <div
                        onClick={() =>
                            width < DESKTOP_BREAKPOINT && setSubLinkToggle(!subLinkToggle)
                        }
                    >
                        {subLinkToggle ? <FaMinus /> : <GoPlus />}{' '}
                    </div>
                )}
            </div>
            <div
                className={styles.dropdownContent}
                style={{
                    height: subLinkToggle ? '100%' : '0'
                }}
            >
                {elem.subLinks.map((subelem, j) =>
                    subelem.external ? (
                        <a
                            key={`sublink_${j}`}
                            className={styles.subLink}
                            href={subelem.url}
                            target='_blank'
                            rel='noreferrer'
                        >
                            {subelem.title}
                        </a>
                    ) : (
                        <Link
                            key={`subLink_${j}`}
                            className={styles.subLink}
                            to={subelem.url}
                            onClick={subelem.onClick}
                        >
                            {subelem.title}
                        </Link>
                    )
                )}
            </div>
        </div>
    );
};

const Navbar = ({ logo, i18n }) => {
    const [toggle, setToggle] = useState(true);
    const location = useLocation();

    const mobileNavToggle = () => {
        setToggle(!toggle);
    };

    const [width, setWidth] = useState(window.innerWidth);
    const handleWindowResize = () => {
        setWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);
    }, []);

    useEffect(() => {
        setToggle(false);
    }, [location]);

    return (
        <div
            className={styles.container}
            // style={{
            //     backgroundColor: width > 1024 && !bgColor && 'rgba(255, 255, 255, 0.3)'
            // }}
        >
            <div className={styles.logoIconContainer}>
                <Link className={styles.logo} to='/'>
                    <img className={styles.logo} src={logo} alt='Logo' />
                </Link>

                <button onClick={mobileNavToggle} className={styles.mobileMenuIcon}>
                    {toggle ? <RiCloseFill size={'25px'} /> : <HiMenu size={'25px'} />}
                </button>
            </div>
            <div
                className={styles.menuContainer}
                style={{
                    transform:
                        width < DESKTOP_BREAKPOINT
                            ? toggle
                                ? 'translateX(0)'
                                : 'translateX(200px)'
                            : 'none',
                    height:
                        width < DESKTOP_BREAKPOINT ? (toggle ? '50vh' : ' 0') : '100%',
                    transition: width < DESKTOP_BREAKPOINT && 'all 0.3s ease-in-out',
                    boxShadow:
                        width < DESKTOP_BREAKPOINT && '0 1px 3px rgb(0 0 0 / 15%)'
                }}
            >
                {menuJson &&
                    menuJson[i18n.language] &&
                    menuJson[i18n.language].map((elem, i) => {
                        if (elem.subLinks)
                            return <Dropdown key={`dropdown_${i}`} elem={elem} width={width} />;
                        else
                            return (
                                <Link key={`Link_${i}`} className={styles.link} to={elem.url}>
                                    {elem.title}
                                </Link>
                            );
                    })}
                {lngs &&
                    Object.keys(lngs).map(lng => (
                        <Link
                            key={lng}
                            className={styles.link}
                            to='#'
                            onClick={e => {
                                e.preventDefault();
                                i18n.changeLanguage(lng);
                            }}
                        >
                            {lngs[lng].displayName}
                        </Link>
                    ))}
            </div>
        </div>
    );
};

export default Navbar;
